module.exports = __webpack_public_path__ + "img/liqpay.a7643273.png";